import * as Yup from 'yup';

export const newTrainingDataSchema = Yup.object().shape({
  passport: Yup.object().shape({
    id: Yup.mixed().nullable(true).required("Identitas Diri harus diisi"),
  }),
  date: Yup.object().shape({
    start: Yup.mixed().required("Tanggal Training harus diisi").nullable(true),
    end: Yup.mixed().required("Tanggal berlaku training harus diisi").nullable(true),
  }),
  type: Yup.mixed().oneOf([1, 2]).required("Jenis Training harus diisi").nullable(true),
  field: Yup.object().shape({
    category: Yup.mixed().required("Bidang Training harus diisi").nullable(true),
    title: Yup.mixed().required("Judul Training harus diisi").nullable(true)
  })
});